import Flex, { FlexProps } from '../../Flex';

const ModalFooter = (props: FlexProps) => {
  return <Flex justifyContent={'center'} alignItems={'center'} {...props} />;
};

export default ModalFooter;
export type { FlexProps as ModalFooterProps };
